import { useEffect } from 'react';
import { useLocation as useRouterLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import api from '../../services/api';

/**
 * Captures ?ref={user_id} from URL and tracks it as a referral.
 * Mounts once globally. Persists in localStorage so it survives login.
 */
const ReferralCapture = () => {
  const location = useRouterLocation();
  const { isAuthenticated, user } = useAuth();

  // 1. On mount/URL change, save ?ref= to localStorage
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const ref = params.get('ref');
    const utm = params.get('utm_source') || 'share';
    if (ref) {
      localStorage.setItem('pending_referrer_id', ref);
      localStorage.setItem('pending_referrer_source', utm);
    }
  }, [location]);

  // 2. When user logs in, send pending referral to backend
  useEffect(() => {
    if (!isAuthenticated || !user) return;
    const pendingRef = localStorage.getItem('pending_referrer_id');
    if (!pendingRef || pendingRef === user.id) return;

    api.post('/referral/track', {
      referrer_user_id: pendingRef,
      utm_source: localStorage.getItem('pending_referrer_source') || 'share',
    })
      .then(() => {
        localStorage.removeItem('pending_referrer_id');
        localStorage.removeItem('pending_referrer_source');
      })
      .catch(() => {});
  }, [isAuthenticated, user]);

  return null;
};

export default ReferralCapture;
